import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  private apiUrl = `${environment.base_url}/notifications`; // URL de ton backend

  constructor(private http: HttpClient) {}

  // Méthode pour envoyer une notification via l'API
  sendNotification(message: string): Observable<any> {
    return this.http.post<any>(this.apiUrl, message);  // Assure-toi de spécifier que tu attends un objet JSON
  }
}
